import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { xl: "12", lg: "12", md: "12", sm: "12", xs: "12" } },
            [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { sm: "2", lg: "2" } },
                    [
                      _c(VSelect, {
                        attrs: {
                          label: _vm.$t("my_tasks.modals.project"),
                          dense: "",
                          outlined: "",
                          disabled: _vm.readonly,
                          items: _vm.projectListDict,
                        },
                        model: {
                          value: _vm.datasource_add.project_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.datasource_add, "project_name", $$v)
                          },
                          expression: "datasource_add.project_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { sm: "3", lg: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          label: _vm.$t("my_tasks.tablas_tasks.name"),
                          dense: "",
                          outlined: "",
                          disabled: _vm.readonly,
                        },
                        model: {
                          value: _vm.datasource_add.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.datasource_add, "name", $$v)
                          },
                          expression: "datasource_add.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { sm: "4", lg: "4" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          label: _vm.$t("my_tasks.modals.description"),
                          dense: "",
                          outlined: "",
                          disabled: _vm.readonly,
                        },
                        model: {
                          value: _vm.datasource_add.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.datasource_add, "description", $$v)
                          },
                          expression: "datasource_add.description",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { sm: "2", lg: "2" } },
                    [
                      !_vm.readonly
                        ? _c(
                            VBtn,
                            {
                              attrs: {
                                outlined: "",
                                color: "secondary",
                                small: "",
                                dense: "",
                                rounded: "",
                              },
                              on: { click: _vm.onAddDatasource },
                            },
                            [_vm._v(_vm._s(_vm.$t("btns.add_item")))]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { sm: "12", lg: "12" } },
                    [
                      _c(VDataTable, {
                        staticClass: "table-inca",
                        attrs: {
                          items: _vm.dsources,
                          headers: _vm.headersDs,
                          "hide-default-footer": _vm.dsources.length <= 10,
                        },
                        scopedSlots: _vm._u(
                          [
                            !_vm.readonly
                              ? {
                                  key: "item.action",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _c(
                                        VTooltip,
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function (ref) {
                                                  var on = ref.on
                                                  var attrs = ref.attrs
                                                  return [
                                                    _c(
                                                      VBtn,
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass:
                                                              "btn-icon-inca",
                                                            attrs: {
                                                              icon: "",
                                                              small: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onRemoveDatasource(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          },
                                                          "v-btn",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c(VIcon, [
                                                          _vm._v("icon-delete"),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("my_tasks.delete"))
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  },
                                }
                              : null,
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }